import { Form, Head, Link, usePage } from '@inertiajs/react'

type PageProps = {
  email: string
  flash?: {
    notice?: string | null
    alert?: string | null
  }
}

export default function AdminDashboard() {
  const { email, flash } = usePage<PageProps>().props

  return (
    <>
      <Head title="Admin" />
      <div className="mx-auto max-w-2xl space-y-8 py-12 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <h1 className="font-headline text-2xl font-bold tracking-tight text-on-surface">Dashboard</h1>
            <p className="mt-2 font-mono text-sm text-on-surface-variant">Signed in as {email}</p>
          </div>
          <div className="flex shrink-0 flex-wrap gap-3">
            <Link href="/admin/password/edit" className="key-btn-secondary inline-flex items-center justify-center">
              Change password
            </Link>
            <Form action="/admin/session" method="delete">
              {({ processing }) => (
                <button type="submit" className="key-btn-secondary" disabled={processing}>
                  Log out
                </button>
              )}
            </Form>
          </div>
        </div>

        {flash?.notice ? (
          <p className="rounded-md border border-primary-container/30 bg-surface-container-high px-4 py-3 font-mono text-sm text-on-surface">
            {flash.notice}
          </p>
        ) : null}

        <div className="space-y-3 font-body text-on-surface-variant">
          <p>
            <Link href="/admin/traffic" className="font-semibold text-primary-container hover:underline">
              Traffic
            </Link>{' '}
            — Visitor requests, approx. unique visitors, top paths, and login audit rows (admin only).
          </p>
          <p>
            <a href="/admin/flipper" className="font-semibold text-primary-container hover:underline">
              Feature flags
            </a>{' '}
            — Flipper UI (full page). Toggle features stored in PostgreSQL.
          </p>
        </div>
      </div>
    </>
  )
}
